<template>
  <button
    type="button"
    role="switch"
    class="custom-switch-list"
    :style="{
      '--left': `calc(${(100 / valueList.length) * (switchValue - 1)}%)`,
    }">
    <span
      v-for="(text, index) in valueList"
      :key="index"
      class="custom-switch-list-text"
      :class="{
        'custom-switch-list-text-checked': index + 1 === switchValue,
      }"
      @click="switchClickHandle(index + 1)">
      <span class="custom-switch-list-text-inner">
        {{ text }}
      </span>
    </span>
    <span class="custom-switch-list-box">
      <span class="custom-switch-list-handle">
        {{ valueList[switchValue - 1] }}
      </span>
    </span>
  </button>
</template>

<script setup>
  import { ref } from "vue";

  const emit = defineEmits(["update:modelValue", "change"]);
  const props = defineProps({
    modelValue: {
      type: Number,
      default: 1,
    },
    valueList: {
      type: Array,
      default: ["A", "B", "C"],
    },
  });

  const switchValue = ref(props.modelValue);

  const switchClickHandle = (index) => {
    switchValue.value = index;
    emit("update:modelValue", switchValue.value);
    emit("change", switchValue.value);
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/css/mixin.scss";
  .custom-switch-list {
    @include flex(center);
    height: 32px;
    min-width: 40px;
    border-radius: 27px;
    border: none;
    background-color: var(--color_lightgray03);
    padding: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    display: inline-flex;
    .custom-switch-list-text {
      @include FontSize_x14;
      padding: 2px 12px;
      color: var(--color_darkgray);
      background-color: var(--color_transparent);
      position: relative;
      z-index: 2;
      transition: 0.2s;
      &.custom-switch-list-text-checked {
        border-radius: 16px;
        color: var(--color_brand);
      }
    }
    .custom-switch-list-box {
      position: absolute;
      inset: 4px;
      .custom-switch-list-handle {
        @extend .custom-switch-list-text;
        @extend .custom-switch-list-text-checked;
        background-color: var(--color_white);
        z-index: 1;
        position: absolute;
        left: var(--left);
        top: 0;
        color: var(--color_transparent);
        transition: 0.2s;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>
